import { crudRequest } from '@/services/api';

const state = {}
for (let dsIndex = 0; dsIndex < 2; dsIndex++) {
  state[`sendSite${dsIndex}`] = {}
}

export default {
  namespace: 'sendSite',
  state: { ...state },

  effects: {
    *sendSite({ payload: { data, dsIndex } }, { call, put, select }) {
      yield put({ type: 'updateState', payload: { [`sendSite${dsIndex}`]: data[0].result } })
    }
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
  }
}